import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { Col, Row } from 'react-bootstrap';
import Logo from '../../../assets/images/logo.png';
import Arrow from '../../../assets/images/arrow.png';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../login.css';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { GetCaptcha, selectCaptcha } from '../../../features/login/captchSlice';
import swal from 'sweetalert';
import EmptyRow from '../../../components/emptyRow/EmptyRow';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import {
  GetNonAdfs,
  selectNonAdfs
} from '../../../features/company/getNonAdfsSlice';
var md5 = require('md5');

const title: String = '';
const required = 'This field is required';
const pattern = 'Please insert valid input';
// Error Component
const errorMessage = (error: any) => {
  return <div className='invalid-feedback'>{error}</div>;
};
function NewUserRegister() {
  let history = useHistory();
  const getCaptcha = useAppSelector(selectCaptcha);
  const nonAdfs = useAppSelector(selectNonAdfs);
  const dispatch = useAppDispatch();
  const [fullName, setfullName] = useState<string>();
  const [companyName, setcompanyName] = useState<any>();
  const [username, setUserName] = useState<string>();
  const [password, setPassword] = useState('');
  const [captcha, setCaptcha] = useState<any>();
  const [remember, setRemember] = useState<string>('no');
  const [loading, setLoading] = useState(false);
  const [passError, showPassError] = useState(false);
  const [domainName, setdomainName] = useState<string>();
  const FullName = (event: React.ChangeEvent<HTMLInputElement>) =>
    setfullName(event.target.value);
  const CompanyName = (event: React.ChangeEvent<HTMLInputElement>) =>
    setcompanyName(event.target.value);
  const Username = (event: React.ChangeEvent<HTMLInputElement>) =>
    setUserName(event.target.value);
  const Password = (event: React.ChangeEvent<HTMLInputElement>) =>
    setPassword(event.target.value);
  const Captcha = (event: React.ChangeEvent<HTMLInputElement>) =>
    setCaptcha(parseInt(event.target.value));
  const Remember = () =>
    remember == 'no' ? setRemember('yes') : setRemember('no');

  const handlecompanyChange = (event: any) => {
    setcompanyName(event.target.value);
  };

  useEffect(() => {
    localStorage.removeItem('userDetails');
    localStorage.removeItem('isSSO');
    async function fetchCaptchaDetails() {
      let sample = await dispatch(GetCaptcha());
    }
    fetchCaptchaDetails();
    async function fetchNonAdfs() {
      let sample = await dispatch(GetNonAdfs(''));
    }
    fetchNonAdfs();
  }, []);
  const userDetails: any = localStorage.getItem('userDetails');
  let userDetailsJson = JSON.parse(userDetails);

  const [isLogin, setIsLogin] = useState(
    userDetailsJson?.accessToken ? userDetailsJson.accessToken : undefined
  );
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    //  event.preventDefault();
    // console.log("captcha =====> ", getCaptcha);
    if (getCaptcha.total != captcha) {
      swal('Incorrect Captcha.', '', 'error');
    } else {
      setLoading(true);
      let data = {
        username: fullName,
        emailId: username,
        companyName: '',
        companyId: parseInt(companyName),
        captchaId: getCaptcha.id,
        captchaTotal: captcha
        //password: md5(password)
      };
      var axios = require('axios');
      var config = {
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/register/user`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      axios(config)
        .then(function (response: any) {
          // console.log(JSON.stringify(response.data.user.otp));
          setLoading(false);
          if (response.status == 200) {
            swal('User Register Successfully', '', 'success');
            // localStorage.setItem('otp', JSON.stringify(response.data.otp));
            history.push({
              pathname: `/setuserpassword/`,
              state: {
                id: username,
                data: data
              }
            });
          }
        })
        .catch(function (error: any) {
          setLoading(false);

          swal(error?.response?.data, '', 'error');
          dispatch(GetCaptcha());
        });
    }
  };

  return (
    <>
      <Container fluid style={{ height: 'auto' }}>
        <Row sm={3}>
          <Col></Col>
          <Col
            className='bg-white tb-mar-mob0-desk48 mx-auto loginshadow'
            xxl={3}
            xs={10}
          >
            <div className='my-5 lr-mar-mob4-desk24'>
              <Image
                className='mx-auto d-block'
                style={styles.limg}
                src={Logo}
              />
              <div className='mt-2 mb-3' style={styles.head}>
                Ethics and Governance portal
              </div>
              <p style={styles.required}>All fields are required </p>
              <form
                onSubmit={handleSubmit(onSubmit)}
                autoComplete='new-password'
              >
                <Form.Group className='mb-3'>
                  <input
                    className='shadow-none'
                    style={styles.text1}
                    type='text'
                    placeholder='Please enter your full name'
                    name='fullName'
                    onChange={FullName}
                    autoComplete='nope'
                    ref={register({ required: true, pattern: /^[a-zA-Z\s]*$/ })}
                  />
                  {errors.fullName &&
                    errors.fullName.type === 'required' &&
                    errorMessage(required)}
                  {errors.fullName &&
                    errors.fullName.type === 'pattern' &&
                    errorMessage(pattern)}
                </Form.Group>
                <Form.Group className='mb-3'>
                  <select
                    ref={register({ required: true })}
                    name='comapnyName'
                    onChange={(event) => handlecompanyChange(event)}
                  >
                    <option value=''> Select Company</option>
                    {nonAdfs?.map((item: any) => {
                      return (
                        <option value={item.id} key={item.id}>
                          {item.company}
                        </option>
                      );
                    })}
                  </select>

                  {errors.companyName &&
                    errors.companyName.type === 'required' &&
                    errorMessage(required)}
                </Form.Group>
                <Form.Group className='mb-3'>
                  <input
                    className='shadow-none'
                    style={styles.text1}
                    type='text'
                    placeholder='Please enter company Email id'
                    name='username'
                    onChange={Username}
                    autoComplete='nope'
                    // ref={register({ required: true, pattern: /^\S+@\S+$/i, })}
                    ref={register({
                      required: true,
                      pattern: {
                        value: /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/,
                        message: 'Please insert valid email Id'
                      }
                    })}
                  />
                  {errors.username &&
                    errors.username.type === 'required' &&
                    errorMessage(required)}
                  {errors.username?.message && (
                    <div className='invalid-feedback'>
                      {errors.username?.message}
                    </div>
                  )}
                </Form.Group>
                {/* <Form.Group className="mb-3">
                <input
                    className="shadow-none"
                    style={styles.text1}
                    type="password"
                    placeholder="Please enter your password"
                    name="password"
                    onChange={Password}
                    autoComplete="nope"
                   // ref={register({ required: true, pattern: /^\S+@\S+$/i, })}
                    ref={register({
                      required: true,
                      pattern: {
                        value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                        message:
                          "Password must be (eg.Example@1)"
                      }
                    })}
                  />
                {errors.password &&
                        errors.password.type === "required" &&
                        errorMessage(required)}  
                        {errors.password?.message && <div className="invalid-feedback">{errors.password?.message}</div>}
                          </Form.Group> */}
                <InputGroup className='mb-3'>
                  <Form.Control
                    className='mt-3 border-end-0 shadow-none'
                    style={styles.text1}
                    type='text'
                    placeholder='Captcha calculation'
                    name='captcha'
                    onChange={Captcha}
                    ref={register({ required: true })}
                  />
                  <InputGroup.Text
                    className='mt-3'
                    style={styles.capcha}
                    id='basic-addon2'
                  >
                    {getCaptcha?.num1}+{getCaptcha?.num2}
                  </InputGroup.Text>
                  {errors.captcha &&
                    errors.captcha.type === 'required' &&
                    errorMessage(required)}
                </InputGroup>

                <a href='/home'>
                  <Button style={styles.btn1} variant='danger' type='submit'>
                    {loading && (
                      <i
                        className='fa fa-refresh fa-spin'
                        style={{
                          marginRight: '1px',
                          fontSize: '18px',
                          color: '#fff'
                        }}
                      />
                    )}
                    &nbsp;&nbsp;&nbsp; SUBMIT
                  </Button>
                </a>
                <EmptyRow />
              </form>
            </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  );
}

const styles: any = {
  required: { color: '#db233a' },
  head: {
    fontFamily: 'Georama-Regular',
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center'
  },
  limg: {
    width: '159px',
    height: '22px'
  },
  img1: {
    width: '24px',
    height: '24px'
  },
  checkb: {
    boxSizing: 'border-box',
    boxShadow: 'inset 0px 0px 0px 2px red'
  },
  text1: {
    fontFamily: 'Saira',
    fontSize: '14px',
    borderRadius: '0px',
    border: 'solid 1px #e4e4e4'
  },
  text2: {
    textAlign: 'right',
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: '600',
    color: 'red',
    textDecoration: 'none'
  },
  text3: {
    fontFamily: 'Georama-Regular',
    fontSize: '14px',
    textAlign: 'center'
  },
  remember: {
    fontFamily: 'Georama-Regular',
    fontSize: '14px',
    fontWeight: 'normal',
    color: 'black'
  },
  btn1: {
    width: '100%',
    height: '48px',
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: '600',
    color: 'white',
    borderRadius: '0px',
    padding: '15px'
  },
  capcha: {
    fontSize: '14px',
    fontFamily: 'Georama-Regular',
    color: '#cdcdcd',
    backgroundColor: 'white',
    borderRadius: '0px',
    border: 'solid 1px #e4e4e4'
  }
};

export default NewUserRegister;
